"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppContextValue = exports.useAppContextProvider = exports.AppContext = void 0;
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
exports.AppContext = react_1.default.createContext({
    language: types_1.SupportedLanguage.sk,
    setLanguage: () => undefined,
});
// eslint-disable-next-line no-underscore-dangle
const currentLanguage = typeof window !== 'undefined' && window.__LANGUAGE__;
const useAppContextProvider = () => {
    // todo take default language from url
    const [language, setLanguage] = react_1.default.useState(currentLanguage || types_1.SupportedLanguage.sk);
    return {
        AppContextProvider: exports.AppContext.Provider,
        value: {
            language,
            setLanguage,
        },
    };
};
exports.useAppContextProvider = useAppContextProvider;
const useAppContextValue = () => {
    const context = react_1.default.useContext(exports.AppContext);
    return context;
};
exports.useAppContextValue = useAppContextValue;
